import Chart from "chart.js";
import moment from "moment";
import React, { Component } from "react";
import PropTypes from "prop-types";
import Timeline from "@material-ui/icons/Timeline";
import { compact, keys, map, sumBy, values } from "lodash";
import { fulfillWith } from "./utils";

import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import UsinaTooltip from "./UsinaTooltip";
import { localeString } from "services/utils";

class ConsumptionChart extends Component {
  componentDidMount() {
    this.handleChart();
  }

  componentDidUpdate() {
    this.handleChart();
  }

  getLabels() {
    let labels = keys(this.props.consolidatedEnergy).map(key => moment(key).format("MMM Y"));
    return fulfillWith(labels, "");
  }

  getData(key) {
    let data = map(values(this.props.consolidatedEnergy), key);
    return fulfillWith(data, undefined);
  }

  handleChart() {
    const ctx = "chart-recurso-requisito";
    const labels = this.getLabels();
    const recurso = this.getData("recurso");
    const requisito = this.getData("requisito");
    const recursoGarantiaFisica = this.getData("recursoConsiderandoGF");

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        datasets: compact([{
          backgroundColor: 'rgba(255, 99, 132, 0.4)',
          borderColor: 'rgba(255,99,132,1)',
          data: requisito,
          fill: false,
          label: 'Requisito (Venda + Consumo)',
          type: 'line',
        }, this.shouldShowGF() && {
          backgroundColor: 'rgba(168, 233, 241, 0.4)',
          borderColor: 'rgba(0, 172, 193, 1)',
          data: recursoGarantiaFisica,
          fill: false,
          label: 'Recurso (Compra + Garantia Física)',
          type: 'line',
        }, {
          backgroundColor: 'rgba(54, 162, 235, 0.4)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
          data: recurso,
          label: 'Recurso (Compra + Geração)',
        }]),
        labels,
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: value => `${localeString(value)} MWh`,
            },
          }],
        },
        tooltips: {
          callbacks: {
            label: tooltipItem => `${localeString(tooltipItem.yLabel)} MWh`,
          },
          intersect: false,
          mode: 'index',
        },
      },
    });
  }

  shouldShowGF() {
    return sumBy(values(this.props.consolidatedEnergy), 'garantiaFisica') > 0;
  }

  render() {
    return (
      <GridContainer>
        <GridItem md={12} sm={12} xs={12}>
          <ECCard
            content={<canvas id="chart-recurso-requisito" />}
            icon={<Timeline />}
            title={
              <UsinaTooltip
                shouldShow={this.shouldShowGF()}
                title="Balanço Energético"
              />
            }
          />
        </GridItem>
      </GridContainer>
    );
  }
};

ConsumptionChart.propTypes = {
  consolidatedEnergy: PropTypes.objectOf(PropTypes.shape({
    garantiaFisica: PropTypes.number.isRequired,
    lastro: PropTypes.number.isRequired,
    recurso: PropTypes.number.isRequired,
    recursoConsiderandoGF: PropTypes.number.isRequired,
    requisito: PropTypes.number.isRequired,
    saldo: PropTypes.number.isRequired,
  })).isRequired,
};

export default ConsumptionChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/ConsumptionChart.jsx